const crypto = require("crypto");

export default {
  getAdfsToken: function() {
    const adfsToken = localStorage.getItem("ADFS_TOKEN");
    return adfsToken && typeof adfsToken !== "undefined" ? adfsToken : "";
  },
  setAdfsToken: function(adfsToken) {
    localStorage.setItem("ADFS_TOKEN", adfsToken);
  },
  getEucToken: function() {
    const eucToken = localStorage.getItem("EUC_TOKEN");
    return eucToken && eucToken === "true" ? true : false;
  },
  setEucToken: function(eucToken) {
    localStorage.setItem("EUC_TOKEN", eucToken);
  },
  decryptToken: function(key, encrypted) {
    const input = Buffer.from(encrypted, "hex");
    const enycryptKey = Buffer.from(key, "hex");
    const iv = input.slice(0, 16);

    const decipher = crypto.createDecipheriv("aes-256-cbc", enycryptKey, iv);
    const decrypted = Buffer.concat([
      decipher.update(input.slice(16)),
      decipher.final()
    ]);
    this.setAdfsToken(decrypted);
  }
};
